import * as yup from 'yup'

export default yup.object().shape({
  applicationAnswer: yup
    .string()
    .required('Please provide an answer to the application question')
    .max(240, 'Answer must be 240 characters or less'),
})
